// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2n4wl","boxTitle":"Qualiphy_boxTitle__2F5W4","box":"Qualiphy_box__3L8i_","toggleWrap":"Qualiphy_toggleWrap__1mKSq"};